export default __webpack_public_path__ + "static/media/rules-periodic.8f0dcbb2.svg";